// src/pages/Dashboard/Admin/DepensesRecettesDashboard/components/AccountingHeader.jsx

import React from "react";
import { FaChartBar, FaDownload, FaPlus } from "react-icons/fa";

import { fmtEUR } from "../utils/accountingDashboardUtils";

export default function AccountingHeader({
  totals,
  filteredCount,
  totalCount,
  season,
  onAdd,
  onExport,
  onOpenCharts,
}) {
  const soldePositive = Number(totals?.solde || 0) >= 0;

  return (
    <header className="overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="relative overflow-hidden bg-slate-950 px-5 py-6 text-white sm:px-7">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(1,62,142,0.55),transparent_36%),radial-gradient(circle_at_bottom_right,rgba(76,168,47,0.35),transparent_34%)]" />

        <div className="relative flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-lime-200">
              Administration club
            </p>

            <h1 className="mt-2 font-display text-2xl font-bold tracking-tight sm:text-3xl">
              Dépenses & recettes
            </h1>

            <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-200">
              Suivez les écritures du club, préparez vos synthèses et posez les
              bases d’un futur bilan comptable d’Assemblée Générale.
            </p>

            <div className="mt-4 flex flex-wrap gap-2 text-xs font-bold">
              <span className="rounded-full bg-white/10 px-3 py-1 ring-1 ring-white/10">
                {filteredCount} opération(s) affichée(s)
              </span>

              <span className="rounded-full bg-white/10 px-3 py-1 ring-1 ring-white/10">
                {totalCount} opération(s) au total
              </span>

              {season && (
                <span className="rounded-full bg-lime-400/15 px-3 py-1 text-lime-100 ring-1 ring-lime-300/20">
                  Saison {season}
                </span>
              )}
            </div>
          </div>

          <div className="grid gap-3 sm:grid-cols-3 lg:w-[520px]">
            <HeaderStat label="Dépenses" value={fmtEUR(totals?.depense)} tone="rose" />
            <HeaderStat label="Recettes" value={fmtEUR(totals?.recette)} tone="emerald" />
            <HeaderStat
              label="Solde"
              value={fmtEUR(totals?.solde)}
              tone={soldePositive ? "emerald" : "rose"}
            />
          </div>
        </div>

        <div className="relative mt-6 flex flex-wrap gap-2">
          <button
            type="button"
            onClick={onAdd}
            className="inline-flex items-center gap-2 rounded-2xl bg-white px-4 py-2 text-sm font-bold text-slate-950 transition hover:bg-slate-100"
          >
            <FaPlus />
            Ajouter une opération
          </button>

          <button
            type="button"
            onClick={onOpenCharts}
            className="inline-flex items-center gap-2 rounded-2xl bg-white/10 px-4 py-2 text-sm font-bold text-white ring-1 ring-white/10 transition hover:bg-white/15"
          >
            <FaChartBar />
            Graphiques
          </button>

          <button
            type="button"
            onClick={onExport}
            className="inline-flex items-center gap-2 rounded-2xl bg-white/10 px-4 py-2 text-sm font-bold text-white ring-1 ring-white/10 transition hover:bg-white/15"
          >
            <FaDownload />
            Exporter
          </button>
        </div>
      </div>
    </header>
  );
}

function HeaderStat({ label, value, tone }) {
  const tones = {
    rose: "border-rose-300/20 bg-rose-400/10 text-rose-100",
    emerald: "border-emerald-300/20 bg-emerald-400/10 text-emerald-100",
  };

  return (
    <div className={`rounded-2xl border px-4 py-3 ${tones[tone] || tones.emerald}`}>
      <p className="text-[10px] font-bold uppercase tracking-[0.18em] opacity-80">
        {label}
      </p>

      <p className="mt-1 truncate text-lg font-bold text-white">{value}</p>
    </div>
  );
}